module.exports = __webpack_public_path__ + "img/copiar.66d43b32.png";